import { createAction, props } from '@ngrx/store';
import { State } from './quick-register.reducer';
import { QuickRegisterRequest } from '@libs/entity-lib';

export const quickRegisterProfile = createAction(
  '[CRUD_LESSOR_PROFILE] Quick Register Profile',
  props<{ profileState: QuickRegisterRequest }>()
);

/**
 * `sessionEstablished`: o cadastro deu certo E a sessão foi confirmada pelo
 * servidor (`GET /signin/me` respondeu). `false` quando não havia sessão a
 * estabelecer (lessor cadastrando cliente) ou quando a verificação falhou — aí
 * o atleta existe mas precisa passar pelo login. Quem navega decide com isso.
 */
export const quickRegisterProfileSuccefully = createAction(
  '[CRUD_LESSOR_PROFILE] Quick Register Profile Succefully',
  props<{ newState: State; sessionEstablished: boolean }>()
);

export const quickRegisterProfileFailed = createAction(
  '[CRUD_LESSOR_PROFILE] Quick Register Profile Failed',
  props<{ error: any }>()
);

export const setLoading = createAction(
  '[CRUD_LESSOR_PROFILE] Quick Set Loading',
  props<{ loading: boolean }>()
);
